<template>
  <div class="gerenciamento-cidades">    
    <g-card class="card-gerenciamento-cidades" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Cidades </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limpar"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="buscaCidades"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>
      
      <g-form>
        <div class="gerenciamento-cidades-conteudo espacamento-filtros">
          <div class="filtro-estado">
            <div class="titulo-conteudo-filtros"> UF </div>
            <PDropDown
            class="dropdown-estado input-label"
            placeholder="Selecione"
            :options="EstadosArray"
            optionValue="id"
            optionLabel="siglaEstado"
            @change="cidadeSelecionadaId = ''"
            v-model="estadoSelecionadoId"
            />
          </div>

          <div class="filtro-cidade">
            <div class="titulo-conteudo-filtros"> Cidade </div>
            <PAutoComplete
            class="autocomplete-cidade input-label"
            :filter="true"
            placeholder="Insira o nome da cidade"
            :suggestions="CidadeArray"
            optionLabel="nomeCidade"
            optionValue="id"
            @complete="getCidades($event.query)"
            v-model="cidadeSelecionadaId"
            />
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        @click="buscaCidades"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>

    <g-card v-if="cidadesTipoFrete.length <= 0" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-if="cidadesTipoFrete.length > 0" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo="Dados das Cidades"
      altura="auto"
      :colunas="Colunas"
      :Paginacao="true"
      :valores="cidadesTipoFrete"
      :NumeroLinhas="8"
      :Filtros="Filtro"
      :FiltrosEspecificos="true"
      :rowEditor="true"
      v-on:duploClickLinha="direcionaDetalhes"
      :Editavel="true"
      TextEditar="Altera o frete da cidade"
      :Imprimivel="false"
      v-on:editar="abrirPopupEdicao"
      >
      </g-data-table>
    </g-card>

    <PDialog  :closable="false" :breakpoints="{ '1025px': '90%' }" style="width: 40%; justify-content: center"
    class="gama-popup" v-model:visible="popupEdicao">
      <template #header>
        <div class="titulo-formulario"> Alterar Tipos de Frete </div>
      </template>

      <div class="grupo-formulario espacamento-filtros">
        <div class="titulo-popup-finalizado"> {{ cidadeSelecionadaEdicao.nomeCidade }} / {{ cidadeSelecionadaEdicao.estado }} </div>
        <div class="conteudo-grupo-formulario">
          <div class="cidade-tipo-frete">
            <div class="checkbox-filtros">
              <div class="frete-fracionado input-checkbox">
                <PCheckBox :binary="true" id="frete-fracionado" class="checkbox-frete-fracionado" v-model="cidadeSelecionadaEdicao.ehFracionado"></PCheckBox>
                <label class="freteFracionado label-checkbox" for="frete-fracionado" > Fracionado </label>
              </div>
              <div class="frete-fechado input-checkbox">
                <PCheckBox :binary="true" id="frete-fechado"  class="checkbox-consultas" v-model="cidadeSelecionadaEdicao.ehFechado"></PCheckBox>
                <label class="freteFechado label-checkbox" for="frete-fechado"> Fechado </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="botoes-popup button-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="230px" 
          altura="35px" 
          @click="fecharPopup"
          >
            CANCELAR
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="230px" 
          altura="35px" 
          @click="atualizarCidade"
          >
            ATUALIZAR   
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import GerenciamentoCidades from "./GerenciamentoCidades.js";
export default GerenciamentoCidades;
</script>

<style scoped>

.cidade-tipo-frete {
  display: flex;
  justify-content: center;
  margin: 15px 0 40px;
}

.titulo-popup-finalizado {
  padding: 10px 0 5px;
  margin: 5px 0 30px;
  border-bottom: 1px solid #f0f0f0;
}

@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-cidades-conteudo {
  display: grid;
  grid-template-columns: minmax(4em, 10em) minmax(4em, 18em);
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.filtro-estado { grid-area: 1 / 1 / 2 / 2; }
.filtro-cidade { grid-area: 1 / 2 / 2 / 3; }
}

@media (min-width:801px) {
.gerenciamento-cidades-conteudo {
  grid-template-columns: minmax(4em, 10em) minmax(4em, 18em) auto;
}
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
